import { render, staticRenderFns } from "./updateWomen.vue?vue&type=template&id=8ec219bc&"
import script from "./updateWomen.vue?vue&type=script&lang=js&"
export * from "./updateWomen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports